import { render, staticRenderFns } from "./EmptyHome.vue?vue&type=template&id=d9620432&scoped=true"
import script from "./EmptyHome.vue?vue&type=script&lang=js"
export * from "./EmptyHome.vue?vue&type=script&lang=js"
import style0 from "./EmptyHome.vue?vue&type=style&index=0&id=d9620432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9620432",
  null
  
)

export default component.exports